import * as React from "react";

import DatePicker from "material-ui/DatePicker";

import MerchantDetailTopBar from "./Ops.Merchants.MerchantDetailTopBar";
import MerchantPaymentsContainer from "app/components/AppComponents/Payments/MerchantPaymentsContainer";
import { match } from "react-router";

type Props = {
  match: match<{ id: string }>;
  setHeader: any;
  history: any;
};

type State = {
  createdAtFrom: string;
  createdAtTo: string;
};

export default class Payments extends React.Component<Props, State> {
  state = {
    createdAtFrom: null,
    createdAtTo: null
  };

  setHeader = (data: any) => {
    this.props.setHeader({
      title: `Ops > ${data.merchant.name}`,
      description: "Merchant summary"
    });
  };

  changeFrom = (event: any, date: Date) => {
    this.setState({ createdAtFrom: date.toISOString() });
  };

  changeTo = (event: any, date: Date) => {
    this.setState({ createdAtTo: date.toISOString() });
  };

  render() {
    return (
      <React.Fragment>
        <MerchantDetailTopBar />
        <section className="padded">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start"
            }}
          >
            <DatePicker
              floatingLabelText="From"
              onChange={this.changeFrom}
              style={{
                width: "200px",
                marginRight: "10px"
              }}
              textFieldStyle={{
                width: "200px"
              }}
            />
            <DatePicker
              floatingLabelText="To"
              onChange={this.changeTo}
              style={{
                width: "200px",
                marginRight: "10px"
              }}
              textFieldStyle={{
                width: "200px"
              }}
            />
          </div>

          <MerchantPaymentsContainer
            name={"ops.merchants.payments"}
            onLoaded={this.setHeader}
            id={this.props.match.params.id}
            createdAtFrom={this.state.createdAtFrom}
            createdAtTo={this.state.createdAtTo}
            history={this.props.history}
          />
        </section>
      </React.Fragment>
    );
  }
}
